/** FundRow 머리 칸 제목(9칸 순서) */
export const FUND_ROW_HEADERS = [
  '펀드명',
  '주요 투자 대상',
  '결성일',
  '결성 규모',
  '투자 단계',
  'Gross IRR',
  'TVPI',
  '소진률',
  '회수 건수',
] as const;
